import ddmbase from 'apis/ddmbase';

export default {
    loadSettings() {
        return ddmbase.get(`/settings`)
            .catch((response) => console.error(response, "API ERROR: /settings"))
    },

}
